import { css } from "@/utils/css";

type Props = React.PropsWithChildren &
    React.HTMLProps<HTMLSpanElement> & {
        isActive?: boolean;
    };

export function Badge({ children, onClick, isActive = false, ...props }: Props) {
    return (
        <span
            className={css("badge inline-flex text-center rounded-3 cursor-pointer", isActive ? "active" : "")}
            onClick={onClick}
            {...props}
        >
            {children}
        </span>
    );
}
